"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _react = _interopRequireDefault(require("react"));
var styles = {
  "list": "List__list__1XaOH"
}; 
require('./List.css');
var List = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var children = props.children,
    testId = props.testId,
    onKeyDown = props.onKeyDown;
  var listRef = _react.default.useRef();
  var getElements = function getElements() {
    var targetElements = listRef.current ? (0, _toConsumableArray2.default)(listRef.current.querySelectorAll('a')) : [];
    return targetElements;
  };
  _react.default.useImperativeHandle(ref, function () {
    return {
      focus: function focus(index) {
        var elements = getElements();
        var element = elements.at(index);
        if (element) {
          element.focus();
        }
      },
      getElements: getElements
    };
  }, []);
  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
    _react.default.createElement("ul", {
      className: styles.list,
      onKeyDown: onKeyDown,
      ref: listRef,
      "data-test-id": "".concat(testId !== null && testId !== void 0 ? testId : 'list', "-matches")
    }, children)
  );
});
var _default = exports.default = List;
//# sourceMappingURL=List.js.map